module.exports = __webpack_public_path__ + "static/img/pc1.cfb79769.png";